<script>
    import {Button, Col, Container, Form, Row} from "@sveltestrap/sveltestrap";
    import {currentPage, eventBridge, loginPin, loginToken} from "../../stores.js";
    import LoginToken from "./LoginToken.svelte";
    import LoginPin from "./LoginPin.svelte";
    import {onMount} from "svelte";
    import Fa from "svelte-fa";
    import {faArrowLeftLong, faMobileRetro, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
    import InputPin from "../form/InputPin.svelte";
    import TokenLabel from "../snippets/TokenLabel.svelte";
    import ConfirmModal from "../modal/ConfirmModal.svelte";

    let validPin = $state(true);

    let showErrorWithRedirect = $state(false);
    let showInvalidPinError = $state(false);
    let errorTitle = $state(), errorMessage = $state();

    let hasBeenSubmitted = false;

    function handleSubmit() {
        if (hasBeenSubmitted) return;

        validPin = true;

        hasBeenSubmitted = true

        $eventBridge.dispatchEvent('kc:login', {
            tokenId: $loginToken.fingerprint,
            pin: $loginPin
        });
    }

    function handleInvalidPin() {
        validPin = false;
        hasBeenSubmitted = false

        if ($loginToken.type === 'HW') {
            errorTitle = "Falsche PIN";
            errorMessage = "Sie haben Ihre PIN falsch eingegeben. Möchten Sie die PIN erneut eingeben?";
            showInvalidPinError = true;
        }
    }

    function handlePinCancel() {
        errorTitle = "PIN Eingabe abgebrochen";
        errorMessage = "Die PIN Eingabe wurde abgebrochen oder es ist ein Fehler bei der Kommunikation mit der Karte aufgetreten.";
        showErrorWithRedirect = true;
    }

    function handleRetryCounterExceeded() {
        errorTitle = "Karte gesperrt";
        errorMessage = "Sie haben Ihre PIN mindestens 3x falsch eingegeben. Bitte kontaktieren Sie Ihren Kartenhersteller oder setzen Sie die PIN mit Ihrer PUK zurück.";
        showErrorWithRedirect = true;
    }

    function handleCardNotInitialized() {
        errorTitle = "Karte noch nicht initialisiert";
        errorMessage = "Sie haben Ihre Karte noch nicht freigeschaltet.";
        showErrorWithRedirect = true;
    }

    function handleGenericError() {
        errorTitle = "Fehler";
        errorMessage = "Es ist ein Fehler aufgetreten.";
        showErrorWithRedirect = true;
    }

    function addEventListeners() {
        $eventBridge.addEventListener('cs:ErrorAuthenticationInvalidPin', handleInvalidPin);
        $eventBridge.addEventListener('cs:Error', handleGenericError);

        if ($loginToken.type === 'HW') {
            $eventBridge.addEventListener('cs:ErrorAuthenticationPinEntryCancellation', handlePinCancel);
            $eventBridge.addEventListener('cs:ErrorAuthenticationRetryCounterExpired', handleRetryCounterExceeded);
            $eventBridge.addEventListener('cs:ErrorAuthenticationCardNotInitialized', handleCardNotInitialized);
        }
    }

    function removeEventListeners() {
        $eventBridge.removeEventListener('cs:ErrorAuthenticationInvalidPin', handleInvalidPin);
        $eventBridge.removeEventListener('cs:Error', handleGenericError);

        if ($loginToken.type === 'HW') {
            $eventBridge.removeEventListener('cs:ErrorAuthenticationPinEntryCancellation', handlePinCancel);
            $eventBridge.removeEventListener('cs:ErrorAuthenticationRetryCounterExpired', handleRetryCounterExceeded);
            $eventBridge.removeEventListener('cs:ErrorAuthenticationCardNotInitialized', handleCardNotInitialized);
        }
    }

    onMount(() => {
        $loginPin = '';
        addEventListeners();

        if ($loginToken.type === 'HW') {
            handleSubmit();
        }

        return () => {
            removeEventListeners();
        };
    });
</script>

{#if $currentPage === LoginPin}
    <h1><button type="button" class="back-button" onclick={() => currentPage.set(LoginToken)} title="Zurück zur Token-Auswahl" data-test-id="loginPin-back"><Fa icon={faArrowLeftLong} color="var(--brak-medium-grey)" /></button> PIN eingeben</h1>

    {#if $loginToken.type === 'HW'}
        <Container>
            <Row style="margin-top: 20px;">
                <Col md={{size: 6, offset: 3}} style="text-align: left; font-size: 20px;" class="ellipsis">
                    <TokenLabel token={$loginToken} />
                </Col>
            </Row>
            <Row style="margin-top: 20px;">
                <Col md={{size: 6, offset: 3}} style="text-align: left; font-size: 20px;">
                    <Fa icon={faMobileRetro} color="var(--brak-dark-blue)"/> Bitte folgen Sie den Anweisungen auf Ihrem Kartenlesegerät.
                </Col>
            </Row>
        </Container>
    {:else}
        <Form on:submit={(event) => {event.preventDefault(); handleSubmit();}}>
            <Container>
                <Row style="margin-top: 20px;">
                    <Col md={{size: 6, offset: 3}} style="text-align: left; font-size: 20px;" class="ellipsis" data-test-id="loginPin-form-token">
                        <TokenLabel token={$loginToken} />
                    </Col>
                </Row>
                <Row style="margin-top: 20px;">
                    <Col md={{size: 6, offset: 3}}>
                        <InputPin bind:pin={$loginPin} invalid={!validPin} autofocus id="brak-idp-pin" autocomplete="off" data-test-id="loginPin-form-input-pin" />
                    </Col>
                </Row>
                <Row style="margin-top: 20px;">
                    <Col md={{size: 6, offset: 3}} style="text-align: right;">
                        <Button color="primary" type="submit" disabled={!$loginPin} title="PIN Eingabe bestätigen" data-test-id="loginPin-form-button-submit">Bestätigen</Button>
                    </Col>
                </Row>
            </Container>
        </Form>
    {/if}

    <ConfirmModal bind:showConfirm={showErrorWithRedirect} confirm={() => ($currentPage = LoginToken)}>
        {#snippet header()}
            <Fa icon={faTriangleExclamation} />{errorTitle}
        {/snippet}

        {errorMessage}
    </ConfirmModal>

    <ConfirmModal
        bind:showConfirm={showInvalidPinError}
        cancelLabel="Abbrechen"
        confirm={() => {handleSubmit();}}
        cancel={() => ($currentPage = LoginToken)}
    >
        {#snippet header()}
            <Fa icon={faTriangleExclamation} />{errorTitle}
        {/snippet}

        {errorMessage}
    </ConfirmModal>
{/if}

<style>
    .back-button {
        margin-right: 0.25em;
        padding: 0;
        border: 0;
        background: none;
    }
</style>
